import { TaskDetailsViewPanels } from '../TaskDetailsViewPanels';
import { useTaskDetailsLocalNavigation } from '../use-task-details-local-navigation';
import type { TaskDetailsViewContentProps } from '../TaskDetailsView.types';

export const TaskDetailsViewContentLocal = (
  props: TaskDetailsViewContentProps
) => {
  const navigation = useTaskDetailsLocalNavigation();

  return <TaskDetailsViewPanels {...props} navigation={navigation} />;
};
